let width = undefined
let height = undefined
let domId = undefined

export default function(parameters = {}) {
    width = parameters.width || width
    height = parameters.height || height
    domId = parameters.domId || domId
    resize()
}

function resize() {
    if(width == undefined) return
    if(height == undefined) return
    if(domId == undefined) return

    const dom = document.getElementById(domId)
    if(dom == undefined) return

    const x = Math.floor(dom.parentElement.clientWidth / width)
    const y = Math.floor(dom.parentElement.clientHeight / height)
    const fontSize = Math.min(x, y) + "px"
    
    dom.style.fontSize = fontSize
    window.document.fontSize = fontSize
}

window.addEventListener("resize", resize)
